import gql from 'graphql-tag';

export const ExportParticipant = gql`
  mutation ExportParticipant(
    $organizationId: ID!
    $participantId: ID!
    $request: ExportParticipantRequest!
  ) {
    exportParticipant(
      organizationId: $organizationId
      participantId: $participantId
      request: $request
    ) {
      id
      name
      state
      createdOn
      startedOn
      completedOn
      response
    }
  }
`;
